import React from 'react';
import * as XLSX from 'xlsx';
import { Button, Header, Icon, Loader, Popup, Segment, Table } from 'semantic-ui-react';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { IconHeader } from '../../Professor/ProfessorInputGrades/css';
import { toast, ToastContainer } from 'react-toastify';

export default class CourseList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: true

        };
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getCourse = this.getCourse.bind(this);
    }
    // imam pristup id ankete proslijedjen preko location(link)
    componentDidMount() {
        localStorage.removeItem('defIndex');
        this.getCourse();
    }
    getCourse() {
        // treba da se vrate svi predmeti a ne samo koji imaju odg
        let obj = {
            id: null
        };

        axios.post(`/questionnaire/staff-results/course-implementations/${JSON.parse(localStorage.getItem('poll')).pollId}/`, { ...obj })
            .then(res => {
                const courses = res.data;
                this.setState({ data: courses, loading: false });
            })
            .catch(err => {
                this.setState({ loading: false });
                // console.log('Failed to fetch courses.');
            });
    }


    getDataToRender() {
        if (this.state.showFiltersOnButton) {
            return this.state.filterData;
        }
        return this.state.data;
    }

    generateAdditionalSheets = async (filteredData) => {
        if (!filteredData || !filteredData.length) {
            // console.warn('⚠️ Nema podataka za generisanje dodatnih sheetova.');
            return [];
        }
        try {
            // console.log("➡️ [generateAdditionalSheets] Start");
    
            const poll = JSON.parse(localStorage.getItem('poll'));
            const pollType = poll.pollType;
            const pollTypeKey = poll.pollTypeKey;
            const pollId = poll.pollId;
    
            //.console.log("📋 Poll info:", { pollType, pollTypeKey, pollId });
    
            const sectionRes = await axios.get(`/questionnaire/get-sections-by-role/${pollType}/`);
            const sections = sectionRes.data;
            // console.log("📦 Sekcije dobijene sa backenda:", sections);
    
            const professorSection = sections.find(section => section.displayName === "Profesor");
    
            if (!professorSection) {
                // console.warn('⚠️ Sekcija sa displayName "Profesor" nije pronađena.');
                return [];
            }
    
            const professorSectionId = professorSection.id;
            // console.log("✅ Profesor sekcija ID:", professorSectionId);
    
            const sheets = [];
    
            // console.log("🎯 Filtrirani predmeti (length):", filteredData.length);
            
            // const merges = []; 
            for (const subject of filteredData) {
                // console.log("🔍 Obrađujem predmet:", subject.courseImplementationName);
    
                const obj = {
                    courseImplementationGroup: pollTypeKey !== 'study program evaluation' && subject.courseImplementationGroupId
                        ? { id: subject.courseImplementationGroupId }
                        : null,
                    courseImplementation: subject.courseImplementationId
                        ? { id: subject.courseImplementationId }
                        : null,
                    studyProgram: subject.studyProgramId
                        ? { id: subject.studyProgramId }
                        : null,
                    organizationalUnitEmployee: pollTypeKey !== 'study program evaluation' && subject.organizationalUnitEmployeeId
                        ? { id: subject.organizationalUnitEmployeeId }
                        : null
                };  
    
                // console.log("📨 Objekat za POST /statistics:", obj);
    
                const statRes = await axios.post(
                    `/questionnaire/statistics/${pollId}/${professorSectionId}/`,
                    obj
                );
    
                const answers = statRes.data.questionDTOS;
                // console.log(`📊 Odgovori za predmet "${subject.courseImplementationName}":`, answers.length);
    
                if (!answers.length) {
                    // console.log("⛔ Preskačem jer nema pitanja.");
                    continue;
                }
    
                const sheet = [];

                // const rowIndexesForComments = []; 
                for (let i = 0; i < answers.length; i++) {
                    const q = answers[i];
                    const headerRow = ["", "Sadržaj pitanja"];
                    if (q.answerDTOS && q.answerDTOS.length > 0) {
                        q.answerDTOS.forEach(ans => {
                            // headerRow.push(ans.questionName);
                            if (!isNaN(ans.questionName)){
                                headerRow.push(Math.trunc(ans.questionName));
                            }
                            else {
                                if(ans.questionName === "text"){
                                    // headerRow.push("Komentari");
                                } else
                                    headerRow.push(ans.questionName); 
                            }
                        });
                        if(q.questionType === 'select') 
                        headerRow.push("Prosjek"); 
                    }
                    sheet.push(headerRow);
                
                    const dataRow = [];
                    dataRow.push(i + 1 + "."); 
                    dataRow.push(q.questionText); 
                
                    if (q.answerDTOS && q.answerDTOS.length > 0) {
                        q.answerDTOS.forEach(ans => {
                            if (ans.questionName !== "text")
                                dataRow.push(ans.numberOfAnswers);
                        });
                        if (q.questionType === 'select') 
                            dataRow.push(parseFloat(q.averagePerQuestion).toFixed(2));
                    }
                    sheet.push(dataRow);
                    sheet.push([]); 
                
                    const textAnswers = q.answerDTOS && q.answerDTOS[0] && q.answerDTOS[0].textAnswers;
                    if (textAnswers && textAnswers.length) {
                        sheet.push([]);
                        sheet.push(['Komentari:']);

                        var commentCount = 1;
                        textAnswers.forEach((comment, idx) => {
                            // const rowIndex = sheet.length;
                            if (!comment || comment.trim() === '') return;
                            sheet.push([`${commentCount++}.`, comment]);
                            // rowIndexesForComments.push(rowIndex);
                        });
                        sheet.push([]);
                    }
                }
    
                const worksheet = XLSX.utils.aoa_to_sheet(sheet);
                const courseBasicComment = subject.courseBasicComment ? `(${subject.courseBasicComment}) ` : "";
                const sheetName = subject.courseImplementationName
                    ? courseBasicComment + subject.courseImplementationName
                    : "Predmet";

                const firstRow = sheet[0] || [];
                const totalCols = firstRow.length;

                const colsWidths = [];
                for (let i = 0; i < totalCols; i++) {
                if (i === 1) {
                    colsWidths.push({ wch: 90 });
                } else {
                    colsWidths.push({ wch: 10 });
                }
                }
                worksheet['!cols'] = colsWidths;
                // worksheet['!merges'] = merges;

                /*
                rowIndexesForComments.forEach((rowIndex) => {   
                    const cellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: 1 });

                    if (worksheet[cellAddress]) {
                        worksheet[cellAddress].s = {
                            alignment: {
                                wrapText: true,
                                vertical: 'top'
                            }
                        };
                    }
                });
                */
    
                // console.log("📝 Dodajem novi sheet:", sheetName);
                // console.log("Sheetname length:", sheetName.length);
                if (sheetName.length > 31) {
                    // console.warn("⚠️ Ime sheet-a je predugačko, skraćujem na 31 znak.");
                    sheetName = sheetName.substring(0, 31);
                }
                sheetName = sheetName.replace(/[\[\]\\\/:\?\*]/g, '-');
                sheets.push({ sheetName, worksheet });
            }
    
            // console.log("✅ Gotovo kreiranje svih sheetova. Ukupno:", sheets.length);
            return sheets;
    
        } catch (error) {
            // console.error('❌ Greška u generateAdditionalSheets:', error);
            throw error;
            // return [];
        }
    };
    
    exportExcelWithMultipleSheets = async () => {
        const data = this.state.data;
        if (!data || !data.length) {
            toast(<FormattedMessage id="poll.noDataForExcelExport" />);
            return;
        }
        try {
            const filteredData = data.filter(el =>
                (el.numberOfStudentsWhoRatedCourse > 0 || el.numberOfStudentsWhoRatedEmployee > 0) &&
                !isNaN(el.averageGradeStaff) &&
                el.averageGradeStaff !== -1
            );
            if (!filteredData || !filteredData.length) {
                // console.log("⚠️ Nema podataka za generisanje Excel datoteke.");
                toast(<FormattedMessage id="poll.noDataForExcelExport" />);
                return;
            }

            const sheetData = [
                [
                    "",
                    "Predmet",
                    "Grupa",
                    "Broj studenata na predmetu",
                    "Broj studenata koji su ocijenili predmet",
                    "Broj studenata koji su ocijenili profesora",
                    "Prosjek"
                ],
                ...data.map((el, index) => ([
                    index + 1 + ".",
                    el.courseImplementationName || '-',
                    el.groupName || '-',
                    el.numberOfStudentsOnCourse !== -1 ? el.numberOfStudentsOnCourse : '-',
                    el.numberOfStudentsWhoRatedCourse || 0,
                    el.numberOfStudentsWhoRatedEmployee || 0,
                    // el.averageGradeStaff !== -1 ? parseFloat(el.averageGradeStaff).toFixed(2) : '-'
                    !isNaN(el.averageGradeStaff) && (el.averageGradeStaff >= 1 && el.averageGradeStaff <= 5) ? parseFloat(el.averageGradeStaff).toFixed(2) : '-'
                ]))
            ];

            const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

            worksheet['!cols'] = [
                { wch: 5 },  
                { wch: 50 }, 
                { wch: 20 }, 
                { wch: 30 }, 
                { wch: 35 }, 
                { wch: 35 }, 
                { wch: 10 }  
            ];

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Predmeti");

            if (filteredData.length !== 0) {
                const additionalSheets = await this.generateAdditionalSheets(filteredData);
                additionalSheets.forEach(({ sheetName, worksheet }) => {
                    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
                });
            }

            const poll = JSON.parse(localStorage.getItem('poll'));
            // console.log(poll);
            // console.log("📥 Spremam Excel datoteku:", poll.pollName);
            XLSX.writeFile(workbook, poll.pollName.toString() + '.xlsx', { cellStyles: true });
            toast(<FormattedMessage id="poll.successfullExcelExport" />);
        } catch (error) {
            // console.error('❌ Greška prilikom generisanja Excel datoteke:', error);
            toast(<FormattedMessage id="poll.errorWhileExcelExport" />);
        }
    };

    render() {
        if (this.state.showResults === true) {
            return (<FormattedMessage id="route.pollResults">
                {(msg) => (<Redirect push to={{ pathname: msg }} />)}
            </FormattedMessage>);
        }
        // const FadeIn = styled.div`animation: 1s ${keyframes`${fadeIn}`}`;
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
        <div>
        
            <div>
                <Header as="h1"> <FormattedMessage id="poll.polls" /> </Header>
                <Segment.Group clearing raised >
                    <Segment> <Header as="h3"> <FormattedMessage id="common.courses" />
                        <Header style={IconHeader} floated="right" >
                            <Icon />
                            <Popup
                                trigger={<Icon
                                    link
                                    circular
                                    basic="true"
                                    floated="right"
                                    name="arrow left"
                                    onClick={() => window.history.go(-1)}
                                />}
                                content={<FormattedMessage id="common.back" />}
                                hideOnScroll
                                position="top center"
                            />
                        </Header></Header></Segment>
                    <Segment>
                        {this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div> :
                            this.state.data.length ?
                                <Table celled selectable compact>
                                    <Table.Header>
                                        <Table.Row >
                                            <Table.HeaderCell >
                                                <FormattedMessage id="common.course" />
                                            </Table.HeaderCell>
                                            <Table.HeaderCell >
                                                <FormattedMessage id="common.group" />
                                            </Table.HeaderCell>
                                            <Table.HeaderCell >
                                                <FormattedMessage id="poll.numberOfStudentsOnCourse" />
                                            </Table.HeaderCell>
                                            <Table.HeaderCell >
                                                <FormattedMessage id="poll.numberOfStudentsWhoDoneCourse" />

                                            </Table.HeaderCell>
                                            <Table.HeaderCell >{localStorage.getItem('activeRole').substr(0, 8) === 'Asistent' ? <FormattedMessage id="poll.numberOfStudentsWhoDoneAssistant" /> : <FormattedMessage id="poll.numberOfStudentsWhoDoneProfessor" />}


                                            </Table.HeaderCell>
                                            <Table.HeaderCell width={1}>
                                                <FormattedMessage id="common.average" />

                                            </Table.HeaderCell>

                                            <Table.HeaderCell textAlign='center'>
                                                <Popup
                                                    trigger={
                                                        <Button
                                                            animated="vertical"
                                                            color="green"
                                                            basic
                                                            fluid
                                                            style={{ textAlign: 'center', width: "auto", margin: '0 auto' }}
                                                            onClick={this.exportExcelWithMultipleSheets}
                                                        >
                                                            <Button.Content hidden>
                                                                <Icon name="download" />
                                                            </Button.Content>
                                                            <Button.Content visible>
                                                                Excel
                                                            </Button.Content>
                                                        </Button>
                                                    }
                                                    content="Preuzmi spisak u Excel-u"
                                                    hideOnScroll
                                                    position="top center"
                                                />
                                            </Table.HeaderCell>


                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {this.getDataToRender().map((el, index) =>
                                            el.numberOfStudentsOnCourse === -1 ?
                                                (<Table.Row
                                                    key={index}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        if (el.numberOfStudentsWhoRatedCourse || el.numberOfStudentsWhoRatedEmployee) {
                                                            localStorage.setItem('courseId', el.courseImplementationId);
                                                            localStorage.setItem('courseName', el.courseImplementationName);
                                                            localStorage.setItem('courseImplementationGroupId', el.courseImplementationGroupId);
                                                            localStorage.setItem('courseImplementationGroupName', el.groupName);
                                                            localStorage.setItem('numberOfStudentsOnCourse', el.numberOfStudentsOnCourse);
                                                            localStorage.setItem('numberOfStudentsWhoRatedCourse', el.numberOfStudentsWhoRatedCourse);
                                                            localStorage.setItem('numberOfStudentsWhoRatedEmployee', el.numberOfStudentsWhoRatedEmployee);
                                                            this.setState({ showResults: true });
                                                        }
                                                    }}
                                                >
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.courseImplementationName ? el.courseImplementationName : '/'}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle" colSpan={6} textAlign="center">
                                                        <FormattedMessage id="poll.lateImplementationMess" />

                                                    </Table.Cell>
                                                </Table.Row>)
                                                :
                                                (<Table.Row
                                                    key={index}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        if (el.numberOfStudentsWhoRatedCourse || el.numberOfStudentsWhoRatedEmployee) {
                                                            localStorage.setItem('courseId', el.courseImplementationId);
                                                            localStorage.setItem('courseName', el.courseImplementationName);
                                                            localStorage.setItem('courseImplementationGroupId', el.courseImplementationGroupId);
                                                            localStorage.setItem('courseImplementationGroupName', el.groupName);
                                                            localStorage.setItem('numberOfStudentsOnCourse', el.numberOfStudentsOnCourse);
                                                            localStorage.setItem('numberOfStudentsWhoRatedEmployee', el.numberOfStudentsWhoRatedCourse);
                                                            localStorage.setItem('numberOfStudentsWhoRatedEmployee', el.numberOfStudentsWhoRatedEmployee);
                                                            this.setState({ showResults: true });
                                                        }
                                                    }}
                                                >
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.courseImplementationName ? el.courseImplementationName : '-'}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.groupName ? el.groupName : '-'}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.numberOfStudentsOnCourse ? el.numberOfStudentsOnCourse : '0'}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.numberOfStudentsWhoRatedCourse ? el.numberOfStudentsWhoRatedCourse : '0'}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.numberOfStudentsWhoRatedEmployee ? el.numberOfStudentsWhoRatedEmployee : '0'}
                                                    </Table.Cell>
                                                    <Table.Cell
                                                        verticalAlign="middle"
                                                        warning={parseFloat(el.averageGradeStaff).toFixed(2) >= 2 && parseFloat(el.averageGradeStaff).toFixed(2) <= 4}
                                                        positive={parseFloat(el.averageGradeStaff).toFixed(2) > 4}
                                                        negative={parseFloat(el.averageGradeStaff).toFixed(2) < 2 && el.averageGradeStaff !== -1}
                                                    >
                                                        {isNaN(el.averageGradeStaff) ||
                                                            parseFloat(el.averageGradeStaff).toFixed(2) === 'NaN' ||
                                                            JSON.stringify(el.averageGradeStaff) === 'NaN' ||
                                                            parseFloat(el.averageGradeStaff).toFixed(2) === '-1.00'
                                                            ? '-' : parseFloat(el.averageGradeStaff).toFixed(2)}
                                                        {/* {el.averageGradeStaff !== -1 ? parseFloat(el.averageGradeStaff).toFixed(2) : '-'} */}
                                                        {/* {parseFloat(el.averageGradeStaff).toFixed(2) < 2 && <Icon color="red" name="attention" />} */}
                                                        {/* {parseFloat(el.averageGradeStaff).toFixed(2) > 4 && <Icon color="green" name="checkmark" />} */}
                                                        {/* {parseFloat(el.averageGradeStaff).toFixed(2)} */}
                                                    </Table.Cell>


                                                    <Table.Cell verticalAlign="middle" textAlign="center">
                                                        {/* link */}

                                                        <Button
                                                            onClick={() => {
                                                                localStorage.setItem('courseId', el.courseImplementationId);
                                                                localStorage.setItem('courseName', el.courseImplementationName);
                                                                localStorage.setItem('courseImplementationGroupId', el.courseImplementationGroupId);
                                                                localStorage.setItem('courseImplementationGroupName', el.groupName);
                                                                localStorage.setItem('numberOfStudentsOnCourse', el.numberOfStudentsOnCourse);
                                                                localStorage.setItem('numberOfStudentsWhoRatedEmployee', el.numberOfStudentsWhoRatedEmployee);
                                                                this.setState({ showResults: true });
                                                            }}
                                                            disabled={!el.numberOfStudentsWhoRatedCourse && !el.numberOfStudentsWhoRatedEmployee}
                                                            basic="true"
                                                            color="blue"
                                                            size="small"
                                                        >
                                                            {/* <Link to={{ */}
                                                            {/*    pathname: '/ankete/predmeti/rezultati', */}
                                                            {/* }} */}
                                                            {/* > */}
                                                            <FormattedMessage id="poll.results" />
                                                            {/* </Link> */}
                                                        </Button>


                                                    </Table.Cell>
                                                </Table.Row>))}
                                    </Table.Body>

                                </Table> : <FormattedMessage id="poll.noCoursesAssigned" />}
                    </Segment>
                </Segment.Group>

            </div>
            <ToastContainer position='top-right' hideProgressBar={true}/>
        </div>    
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Poll/ProfessorPoll/CourseList.js